import React, { useState } from 'react'
import PolaroidModal from '../../../../components/polaroid-modal/polaroid-modal'

// import imageFront from '../../../../assets/images/hotel/ringarens-front.jpg'
// import imageSurrounding1 from '../../../../assets/images/hotel/ringarens-surroundings.jpg'
// import imageSurrounding2 from '../../../../assets/images/hotel/ringarens-surroundings-2.jpg'

// import imageFrontRoad from '../../../../assets/images/optimized/r-front-road-colorful.webp'
import imageFrontRoadAlt from '../../../../assets/images/optimized/r-front-road-colorful-2.webp'
import imageOutside from '../../../../assets/images/optimized/r-outside.webp'
import imageAlmedalen from '../../../../assets/images/optimized/almedalen.webp'
import imageStoraTorget from '../../../../assets/images/optimized/stora-torget.webp'
import imageStrandPromenaden from '../../../../assets/images/optimized/strandpromenaden.webp'

import './showcase-visby.css'

const images = [
  // { src: imageFrontRoad, alt: "Ringarens Hotell ligger på en lugn gata i Visby" },
  { src: imageFrontRoadAlt, alt: "Pittoreska gränder i Visby" },
  { src: imageOutside, alt: "Havsutsikt från Visby" },
  { src: imageAlmedalen, alt: "Den vackra parken Almedalen i Visby" },
  { src: imageStoraTorget, alt: "Stora Torget i Visby med historisk arkitektur" },
  { src: imageStrandPromenaden, alt: "Strandpromenaden i Visby med utsikt över havet" },
];


const ShowcaseVisby = () => {
  const [currentImage, setCurrentImage] = useState(null);

  const handleImageClick = (image) => {
    setCurrentImage(image);
  };

  const handleClose = () => {
    setCurrentImage(null);
  };

  return (
    <section className="home__visby">

      <h2>Upptäck Visby</h2>
      <p>
        Visby, en pärla på Gotland, är känd för sin välbevarade medeltida stadskärna och den imponerande ringmuren som omger staden. Promenera längs de smala kullerstensgatorna, utforska historiska byggnader och njut av den unika atmosfären som kombinerar historia med modern livsstil. Oavsett om du är intresserad av kultur, natur eller gastronomi, har Visby något att erbjuda varje besökare.
      </p>
      <p>
        Från de pittoreska gränderna till de vackra stränderna runt ön, erbjuder Visby en oförglömlig upplevelse för alla som besöker. Missa inte chansen att utforska denna historiska stad under din vistelse hos oss på Ringarens Lägenhetshotell.
      </p>

      <div className="showcase-visby">
        {images.map((image, index) => (
          <button
            aria-label={`View ${image.alt}`}
            className="showcase-visby__polaroid"
            onClick={() => handleImageClick(image)}
            key={index}
            style={{ transform: `rotate(${image.tilt}deg)` }}
          >
            <div className="showcase-visby__image">
              <img src={image.src} alt={image.alt} />
            </div>
            <div className="showcase-visby__caption">{image.alt}</div>
          </button>
        ))}
      </div>

      <PolaroidModal
        open={currentImage !== null}
        onClose={handleClose}
        image={currentImage?.src}
        caption={currentImage?.alt}
      />
    </section>
  )
}

export default ShowcaseVisby
